import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import ReactTable from "react-table";
import { useTranslation } from 'react-i18next';

// ui icons
import Assignment from "@material-ui/icons/Assignment";
import Edit from "@material-ui/icons/Edit";

// ui components
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import Slide from "@material-ui/core/Slide";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";

// core components 
import Card from "beaktShared/components/Card/Card.js";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import AlteracaoVendaForm from "beaktMatriz/views/Vendas/AlteracaoVendaForm.js";

// services
import { MaskCPF, formateDateandTime, transformValueFloattoFormated, MaskOnlyNumbers } from "beaktShared/helpers/masks";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function AlteracaoVendaList() {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();
    const { register, setValue, errors, setError, clearError, getValues } = useForm({ mode: "onBlur" });

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification({ show: false });
        }, 6000);
    };

    const [isLoadingList, setisLoadingList] = React.useState(false);
    const [list, setlist] = React.useState([]);

    const handleClickPesquisa = () => {
        let data = getValues();

        if ((data.vendaContrato == "" || data.vendaContrato == undefined) && (data.cpfCliente == "" || data.cpfCliente == undefined)) {
            showNotification('Informe o número da venda ou CPF do cliente para pesquisar!', 'danger');
            return false;
        }
        else {

            let obj = {
                estabelecimentoId: 0,
                dataIni: null,
                dataFim: null,
                clienteId: 0,
                cpfCliente: data.cpfCliente,
                vendaId: data.vendaContrato,
                franquiaId: session.franquiaId,
            }

            setisLoadingList(true);
            let endPoint = "vendas/byestabelecimentoeperiodo/";
            UsePostApi(endPoint, obj).then(result => {
                if (result.status !== 200) {
                    showNotification(result.message, 'danger')
                    setisLoadingList(false);
                    return false;
                }

                var listFiltered = 
                    result.data.filter(obj => 
                        (obj.statusVendaDesc === 'Finalizado - Ativo' || 
                         obj.statusVendaDesc === 'Finalizado - Concluído' || 
                         obj.statusVendaDesc === 'Cancelado'));

                setlist(listFiltered);
                setisLoadingList(false);

                return true;
            });
        }

    };
    const [showEditContrato, setshowEditContrato] = React.useState(false);
    const [detalhesVenda, setdetalhesVenda] = React.useState([]);

    const handleEdit = (row) => {

        const endPoint = "vendas/dadosalteracaovenda/" + row.vendaId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger')
                setshowEditContrato(false);
                return false;
            }

            setdetalhesVenda(result.data);
            setshowEditContrato(true);

        });
    };

    const handleReturnEditVenda = (result) => {
        if(result)
            showNotification("Venda alterada com sucesso!", 'success')
        
        setshowEditContrato(false);
        setlist([]);
    }

    const columnsProp = [
        {
            Header: t('label.establishment'),
            accessor: "estabelecimentoDescricao",
            style: { textAlign: 'center' },
        },
        {
            Header: "Nº" + t('sale.sale'),
            accessor: "idNetClinicas",
            style: { textAlign: 'center' },
        },
        {
            Header: t('label.date'),
            accessor: "dataCadastro",
            Cell: (props) => {
                let custom_date = formateDateandTime(props.value);
                return <span>{custom_date}</span>
            }
        },
        {
            Header: t('dashboard.seller'),
            accessor: "usuarioNome"
        },
        {
            Header: t('label.client'),
            accessor: "clienteNome"
        },
        {
            Header: t('label.total'),
            accessor: "totalVenda",
            Cell: (props) => <div> {transformValueFloattoFormated(props.value)} </div>
        },
        {
            Header: t('label.status'),
            accessor: "statusVendaDesc",
        },
    ]
    const columnsAcao = [
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">
                    <Button
                        justIcon round simple color="info"
                        onClick={() => handleEdit(row.original)}
                    >
                        <Edit />
                    </Button>{" "}
                </div>
            ),
            sortable: false,
            filterable: false
        }
    ];

    const columns = [...columnsProp, ...columnsAcao]

    return (

        <div>

            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification({ show: false })}
                close
            />
            {!showEditContrato &&
                <GridContainer className="no-print">
                    <GridItem xs={12}>
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <Assignment />
                                </CardIcon>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label={'Nº ' + t('sale.sale')}
                                                variant="outlined"
                                                name="vendaContrato"
                                                defaultValue={""}
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={register({ required: false })}
                                                autoComplete="off"
                                                inputProps={{maxLength: 10}}   
                                                onInput={(e) => MaskOnlyNumbers(e) }
                                            />
                                            {errors.vendaContrato &&
                                                <FormHelperText>
                                                    <span className="obg"></span>
                                                </FormHelperText>}
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={4}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label={t('label.cpf')}
                                                variant="outlined"
                                                name="cpfCliente"
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={register({ required: false })}
                                                autoComplete="off"
                                                InputProps={{
                                                    inputComponent: MaskCPF
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={4}>
                                        <Button round color="primary"
                                            onClick={e => { handleClickPesquisa() }}>
                                            {t('label.search')}
                                        </Button>
                                    </GridItem>
                                </GridContainer>
                                <ReactTable
                                    loading={isLoadingList}
                                    data={list}
                                    columns={columns}
                                    filterable
                                    defaultFilterMethod={noCaseSensitive}
                                    defaultPageSize={10}
                                    minRows={10}
                                    showPaginationBottom={true}
                                    className="-striped -highlight"
                                    previousText={t('button.previous')}
                                    nextText={t('button.next')}
                                    loadingText={t('label.loading') + "..."}
                                    noDataText={t('information_message.no_records_found') + "!"}
                                    pageText={t('label.page')}
                                    ofText={t('label.of')}
                                    rowsText={t('label.rows')}
                                />
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>

            }


            {showEditContrato &&
                <AlteracaoVendaForm detalheVenda={detalhesVenda} CallbackEditVenda={handleReturnEditVenda}></AlteracaoVendaForm>
            }
        </div>
    );
}

